import React from 'react';
import PropTypes from 'prop-types';

export function SvgMove(props) {
  const { width = 16, height = 16, stroke = '#000' } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path
          fill={stroke}
          d="M8.00000039 1L5.5436818 3.45631544 6.28159553 4.19423567 7.47815999 2.99767436 7.47815999 7.47815229 2.99766904 7.47815229 4.1942335 6.28159099 3.45631978 5.54369048 1 8.00000592 3.45631978 10.4563214 4.1942335 9.71840112 2.99766904 8.52183982 7.47815999 8.52183982 7.47815999 13.0023375 6.28159553 11.8057762 5.5436818 12.5436767 8.00000039 14.9999921 10.4563192 12.5436767 9.71840546 11.8057762 8.521841 13.0023375 8.521841 8.52183982 13.0023319 8.52183982 11.8057675 9.71840112 12.5436812 10.4563214 15 8.00000592 12.5436812 5.54369048 11.8057675 6.28159099 13.0023319 7.47815229 8.521841 7.47815229 8.521841 2.99767436 9.71840546 4.19423567 10.4563192 3.45631544z"
        />
      </g>
    </svg>
  );
}

SvgMove.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
};
